import React from "react";
import { Admin, CustomRoutes, Resource } from "react-admin";
import "./App.css";
import { layout } from "./layout/Layout";
import theme from "./layout/Theme";
import { CategoryCreate, CategoryEdit, CategoryList } from "./modules/Category";
import { OfferCreate, OfferEdit, OfferList, OfferShow } from "./modules/Offers";
import {
  SubCategoryCreate,
  SubCategoryEdit,
  SubCategoryList,
} from "./modules/SubCategory";
import { AuctionCreate, AuctionEdit, AuctionList } from "./modules/Auctions";
import { authProvider } from "./utils/authProvider";
// import { authProvider } from './utils/authProvider';
import { dataProvider } from "./utils/fetch";
import { RequestEdit, RequestList } from "./modules/Requests";
import { SupervisorCreate, SupervisorList } from "./modules/Supervisors";
import { InputCreate, InputEdit, InputList } from "./modules/Inputs";
import CustomFileList, { KnowledgeManagerCreate, KnowledgeManagerList, knowledgeManagerCreate, knowledgeManagerList } from "./modules/knowledgeManager";

import { ServiceTypeCreate, ServiceTypeEdit, ServiceTypeList } from "./modules/ServiceTypes";
import { AdminsCreate, AdminsEdit, AdminsList } from "./modules/Admins";
import { UserCreate, UsersList } from "./modules/Users";
import { LogsList } from "./modules/Logs";
import { FeedbacksList } from "./modules/Feedbacks";
import { Statistics } from "./modules/statistics";
import { BlogsCreate, BlogsEdit, BlogsList } from "./modules/Blogs";
import { AlertsCreate, AlertsEdit, AlertShow, AlertsList } from "./modules/Alerts";
import { ConsultationShow, ConsultationsList } from "./modules/Consultations";
import { OrderEdit, OrderList, OrderShow } from "./modules/Orders";
import { AdminInvoiceCreate, InvoiceEdit, InvoiceList, InvoiceShow } from "./modules/Invoices";
import NegotiationCreate, { NegotiationShow, NegotiationsList } from "./modules/Negotiations";
// import ReportsPage from "./modules/Reports";
import UsersReport from "./modules/reports/UsersReport";
import { Navigate, Route } from 'react-router-dom';
import OrdersReports from "./modules/reports/OrdersReports";
import OverallReports from "./modules/reports/OverallReports";
import InputProductList, { InputProductCreate, InputProductEdit, InputProductShow } from "./modules/InputProducts";
import ServiceList, { ServiceCreate, ServiceEdit, ServiceShow } from "./modules/Services";
import TypesReports from "./modules/reports/TypeReports";
import { SmsDeliveryReportsList } from "./modules/SmsDeliveryReports";
import { GalleryCreate, GalleryEdit, GalleryList } from "./modules/Gallery";
import { MediaCategoriesCreate, MediaCategoriesEdit, MediaCategoriesList } from "./modules/MediaCategoriesList";
import { CallRecordsList, CallRecordShow } from "./modules/CallRecords";
import CallReports from "./modules/reports/CallReports";
import InKindReports from "./modules/reports/InKindBaseReport";
import InKindOffersReport from "./modules/reports/InKindOffersReport";
import InKindServicesReport from "./modules/reports/InKindServicesReport";
import { BeneficiariesList, BeneficiaryEdit, BeneficiaryShow } from "./modules/Beneficiaries";
import InKindOrdersReport from "./modules/reports/InKindOrdersReports";
import InKindOfferCreate, { InKindOfferEdit } from "./modules/components/inkind/inkind-offer-create";
import Offers from "./modules/reports/teerab/Offers";
import TeerabRequests from "./modules/reports/teerab/Requests";
import Orders from "./modules/reports/teerab/Orders";
import Requests from "./modules/reports/thabat/Requests";
import ThabatOffers from "./modules/reports/thabat/Offers";
import Overview from "./modules/reports/overview/OverallReports";
import { StateEdit, StateList } from "./modules/location/States";
import { CityEdit, CityList } from "./modules/location/City";
import { LocalityEdit, LocalityList } from "./modules/location/Locality";
import InKindServiceCreate, { InKindServiceEdit } from "./modules/components/inkind/inkind-service-create";
import ProfilePage from "./modules/Profile";
import AuthCheck from "./utils/AuthCheck";
import SalatCategoriesPage from "./modules/salatMahsool/Categories";
import SalatProductsPage from "./modules/salatMahsool/Products";
import SalatOrdersPage from "./modules/salatMahsool/Orders";

// Add this custom dashboard component
const Dashboard = () => {
  // return <Navigate to="/reports/overall" replace />;
  return <Navigate to="/reports/overview" replace />;
};

function App() {
  return (
    <>
      <Admin
        dataProvider={dataProvider}
        authProvider={authProvider}
        layout={layout}
        theme={theme}
        requireAuth
        dashboard={Dashboard}
      >
        {/* <Resource name="statistics" list={Statistics} /> */}

        <CustomRoutes>
          <Route path="/reports/overall" element={<OverallReports />} />
          <Route path="/reports/overview" element={<Overview />} />
          <Route path="/reports/users" element={<UsersReport />} />
          <Route path="/reports/orders" element={<OrdersReports />} />
          <Route path="/reports/in-kind-orders" element={<InKindOrdersReport />} />
          <Route path="/reports/services" element={<TypesReports reportType="services" />} />
          <Route path="/reports/offers" element={<TypesReports reportType="offers" />} />
          <Route path="/reports/inputs" element={<TypesReports reportType="inputs" />} />

          <Route path="/reports/teerab-orders" element={<Orders />} />
          <Route path="/reports/teerab-offers" element={<Offers />} />
          <Route path="/reports/teerab-requests" element={<TeerabRequests />} />

          <Route path="/reports/thabat-requests" element={<Requests />} />
          <Route path="/reports/thabat-offers" element={<ThabatOffers />} />

          {/* <Route path="/reports/in-kind-offers" element={<InKindReports />} />
          <Route path="/reports/in-kind-services" element={<InKindReports />} /> */}
          <Route path="/reports/in-kind-offers" element={<InKindOffersReport />} />
          <Route path="/reports/in-kind-services" element={<InKindServicesReport />} />
          <Route path="/reports/calls" element={<CallReports />} />

        </CustomRoutes>
        <Resource name="logs" list={LogsList} />
        <Resource name="sms-delivery-reports" list={SmsDeliveryReportsList} />
        <Resource
          name="admins"
          list={AdminsList}
          create={AdminsCreate}
          edit={AdminsEdit}
        />

        <Resource
          name="users"
          list={UsersList}
          create={UserCreate}
        />

        <Resource
          name="beneficiaries"
          list={BeneficiariesList}
          edit={BeneficiaryEdit}
          show={BeneficiaryShow}
        // create={BeneficiariesCreate}
        />

        <Resource
          name="category"
          list={CategoryList}
          create={CategoryCreate}
          edit={CategoryEdit}
        />
        <Resource
          name="servicetypes"
          list={ServiceTypeList}
          create={ServiceTypeCreate}
          edit={ServiceTypeEdit}
        />
        <Resource
          name="media-categories"
          list={MediaCategoriesList}
          create={MediaCategoriesCreate}
          edit={MediaCategoriesEdit}
        />
        <Resource
          name="offers"
          list={OfferList}
          create={OfferCreate}
          edit={OfferEdit}
          show={OfferShow}
        />

        <Resource
          name="in-kind-offers"
          create={InKindOfferCreate}
          edit={InKindOfferEdit}
          // show={InKindOfferShow} // Optional: add if you create a show component
          options={{ label: 'In-Kind Offers' }}
        />

        <Resource
          name="in-kind-services"
          create={InKindServiceCreate}
          edit={InKindServiceEdit}
          // show={InKindOfferShow} // Optional: add if you create a show component
          options={{ label: 'In-Kind Services' }}
        />

        <Resource
          name="input-products"
          list={InputProductList}
          create={InputProductCreate}
          edit={InputProductEdit}
          show={InputProductShow}
        />
        <Resource
          name="services"
          list={ServiceList}
          create={ServiceCreate}
          edit={ServiceEdit}
          show={ServiceShow}
        />
        <Resource
          name="invoices"
          options={{ label: "Invoices" }} // Explicitly set the label
          list={InvoiceList}
          show={InvoiceShow}
          create={AdminInvoiceCreate}
          edit={InvoiceEdit}
        />

        <Resource
          name="negotiations"
          list={NegotiationsList}
          create={NegotiationCreate}
          show={NegotiationShow}
        />

        <Resource
          name="orders"
          list={OrderList}
          show={OrderShow}
          edit={OrderEdit}
        />
        <Resource
          name="sub_category"
          list={SubCategoryList}
          create={SubCategoryCreate}
          edit={SubCategoryEdit}
        />
        <Resource
          name="blogs"
          list={BlogsList}
          create={BlogsCreate}
          edit={BlogsEdit}
        />
        <Resource
          name="gallery"
          list={GalleryList}
          create={GalleryCreate}
          edit={GalleryEdit}
        />
        <Resource
          name="alerts"
          list={AlertsList}
          create={AlertsCreate}
          edit={AlertsEdit}
          show={AlertShow}
        />
        <Resource
          name="call-records"
          list={CallRecordsList}
          show={CallRecordShow}
        />
        <Resource
          name="consultations"
          list={ConsultationsList}
          show={ConsultationShow}
        />
        <Resource
          name="auctions"
          list={AuctionList}
          // create={AuctionCreate}
          edit={AuctionEdit}
        />
        <Resource name="biddings" list={RequestList} edit={RequestEdit} />
        {/* <Resource
          name="supervisors"
          list={SupervisorList}
          create={SupervisorCreate}
        />
        edit={SubCategoryEdit} */}
        <Resource
          name="inputs"
          list={InputList}
          create={InputCreate}
          edit={InputEdit}
        />
        <Resource
          name="knowledgeManager"
          list={KnowledgeManagerList}
          create={KnowledgeManagerCreate}
        // edit={InputEdit}
        />
        <Resource name="feedbacks" list={FeedbacksList} />
        <Resource name="state"
          list={StateList}
          // create={StateCreate}
          edit={StateEdit}
        />

        <Resource name="locality"
          list={LocalityList}
          edit={LocalityEdit}
        />
        <Resource name="city"
          list={CityList}
          edit={CityEdit}
        />
        <Resource name="market" />
        <Resource name="unit" />
        {/* <Resource name="users" /> */}

        <CustomRoutes>
          <Route path="/profile" element={<ProfilePage />} />
        </CustomRoutes>

        <CustomRoutes>
          <Route
            path="/salat-mahsool/products"
            element={<AuthCheck><SalatProductsPage /></AuthCheck>}
          />
          <Route
            path="/salat-mahsool/categories"
            element={<AuthCheck><SalatCategoriesPage /></AuthCheck>}
          />
          <Route
            path="/salat-mahsool/orders"
            element={<AuthCheck><SalatOrdersPage /></AuthCheck>}
          />
        </CustomRoutes>
      </Admin>
    </>
  );
}

export default App;
